// src/modules/requerimiento/hooks/useConsultaPlataformas.js
import { useCallback, useEffect, useRef, useState } from "react";
import { consultarPlataformasModem } from "../utils/plataformasModem";
import { claveReporte } from "./useVerificacionReporte";

// Cuántos equipos se consultan a la vez (cada uno consulta varias plataformas).
const CONSULTAR_EN_PARALELO = 3;

/**
 * Consulta detallada de plataformas de una lista de equipos (ver consultarPlataformasModem).
 * consultas: clave -> "verificando" | resultado. Al desmontar o al pedir otra consulta general se corta la anterior.
 */
export default function useConsultaPlataformas() {
  const [consultas, setConsultas] = useState({});
  const consultaRef = useRef(0);

  const consultarUno = useCallback(async (m) => {
    const clave = claveReporte(m);
    if (!clave) return;
    setConsultas((prev) => ({ ...prev, [clave]: "verificando" }));
    let res;
    try {
      res = await consultarPlataformasModem({ num_sim: m.num_sim, emai: m.emai });
    } catch {
      res = { estado: "no_se_pudo", plataformas: [] };
    }
    setConsultas((prev) => ({ ...prev, [clave]: res }));
  }, []);

  const consultarTodos = useCallback(async (lista) => {
    const id = ++consultaRef.current;
    const unicos = new Map();
    (lista || []).filter(claveReporte).forEach((m) => { if (!unicos.has(claveReporte(m))) unicos.set(claveReporte(m), m); });
    const pendientes = Array.from(unicos.values());
    setConsultas(Object.fromEntries(pendientes.map((m) => [claveReporte(m), "verificando"])));
    let i = 0;
    const trabajador = async () => {
      while (i < pendientes.length && id === consultaRef.current) {
        const m = pendientes[i++];
        await consultarUno(m);
      }
    };
    await Promise.all(Array.from({ length: CONSULTAR_EN_PARALELO }, trabajador));
  }, [consultarUno]);

  useEffect(() => () => { consultaRef.current += 1; }, []);

  return { consultas, consultarUno, consultarTodos };
}
